var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1389 7.68799C15.1389 4.58139 12.6205 2.06299 9.51392 2.06299C6.40731 2.06299 3.88892 4.58139 3.88892 7.68799",
    stroke: "white",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.51392 7.68799C0.961631 7.68799 0.513916 8.1357 0.513916 8.68799V21.313C0.513916 21.8653 0.961632 22.313 1.51392 22.313H17.5139C18.0662 22.313 18.5139 21.8653 18.5139 21.313V8.68799C18.5139 8.1357 18.0662 7.68799 17.5139 7.68799H1.51392ZM10.9202 13.313C10.9202 12.5363 10.2906 11.9067 9.51392 11.9067C8.73727 11.9067 8.10767 12.5363 8.10767 13.313V17.2505C8.10767 18.0271 8.73727 18.6567 9.51392 18.6567C10.2906 18.6567 10.9202 18.0271 10.9202 17.2505V13.313Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.9738a5f314ed6f273ab410cdbc4be1f4.svg";
export { ForwardRef as ReactComponent };